// extracted by mini-css-extract-plugin
module.exports = {"card":"Tag_card__2DEDR","active":"Tag_active__21KqO","inactive":"Tag_inactive__nzXSf"};